import _ButtonBase from "@material-ui/core/esm/ButtonBase";
import _InputBase from "@material-ui/core/esm/InputBase";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement } from 'swag-client-common/constants';
import classes from '../../instant-quote-popup.scss';
import { numberInRange } from '../../../../../../../../common/utils/numbers';
class NumberInput extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleButtonPress", step => {
      const {
        max,
        min,
        onChange,
        value
      } = this.props;
      const target = {
        value: numberInRange(+value + step, min, max)
      };
      onChange({
        target
      });
    });
    _defineProperty(this, "handleInputChange", e => {
      const {
        onChange,
        min,
        max
      } = this.props;
      const {
        value
      } = e.target;
      e.target.value = numberInRange(+value, min, max);
      onChange(e);
    });
    _defineProperty(this, "handleIncreaseClick", () => {
      this.handleButtonPress(1);
    });
    _defineProperty(this, "handleDecreaseClick", () => {
      this.handleButtonPress(-1);
    });
  }
  render() {
    const {
      max,
      min,
      dataBlock = '',
      placeholder = '',
      value,
      id,
      disabled,
      tooltipMessage
    } = this.props;
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: tooltipMessage,
      placement: Placement.LEFT,
      mode: "light",
      disableHoverListener: !disabled,
      className: classes.numberInput
    }, /*#__PURE__*/React.createElement(_InputBase, {
      "data-block": dataBlock,
      id: id,
      inputProps: {
        className: classes.numberInputElement
      }
      // @ts-ignore
      ,
      min: min,
      max: max,
      type: "text",
      value: value,
      placeholder: placeholder,
      onChange: this.handleInputChange,
      disabled: disabled
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.modifierBox
    }, /*#__PURE__*/React.createElement(_ButtonBase, {
      "data-button": "Increase",
      className: classes.modifierButton,
      onClick: !disabled ? this.handleIncreaseClick : () => null
    }, "+"), /*#__PURE__*/React.createElement(_ButtonBase, {
      "data-button": "Decrease",
      className: classes.modifierButton,
      onClick: !disabled ? this.handleDecreaseClick : () => null
    }, "-")));
  }
}
export default NumberInput;